import { createSlice } from '@reduxjs/toolkit';
import {
  updateLiveChatSender,
  toggleAWSSenderStatus,
  getLiveChatSender,
} from './operations';

const initialState = {
  liveChatSender: {},
};

const slice = createSlice({
  name: 'liveChatSender',
  initialState,
  reducers: {
    updateLiveChatSenders: (state, action) => {
      state.liveChatSender = { ...state.liveChatSender, ...action.payload };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getLiveChatSender.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getLiveChatSender.fulfilled, (state, { payload }) => {
        state.liveChatSender = payload;

        state.isLoading = false;
      })
      .addCase(getLiveChatSender.rejected, (state, { payload }) => {
        state.error = payload;
        state.isLoading = false;
      })

      .addCase(updateLiveChatSender.fulfilled, (state, { payload }) => {
        state.liveChatSender = payload;
      })

      // ✅ toggle AWS sender status
      .addCase(toggleAWSSenderStatus.fulfilled, (state, { payload }) => {
        state.liveChatSender.status = payload.status;
      });
  },
});

export const { clearLiveChatSenders, updateLiveChatSenders } = slice.actions;
export default slice.reducer;
